import {
  IconLayerProps,
  PathLayerProps,
  PolygonLayerProps,
  ScatterplotLayerProps,
} from "@deck.gl/layers";

import { XYLocation } from "@nens/deck-gl";

import { COLORS, ICON_MAPPING } from "@/config/deckgl-conts";
import IconAtlas from "@/images/iconAtlas.png";

export const DEFAULT_PATH_LAYER_PROPS: Partial<PathLayerProps<XYLocation>> = {
  widthMaxPixels: 15,
  positionFormat: `XY`,
  _pathType: "open",
  opacity: 1,
  capRounded: true,
  jointRounded: true,
  getPath: (d) => d.flat().flat(),
  getWidth: 0.5,
  widthMinPixels: 1,
  pickable: false,
  getColor: COLORS.BLUE,
} as const;

export const DEFAULT_POLYGON_LAYER_PROPS: Partial<PolygonLayerProps<XYLocation>> = {
  lineWidthMinPixels: 1,
  getPolygon: (d) => d.flat().flat(),
  getElevation: 0,
  getFillColor: COLORS.BLUE_50,
  getLineColor: COLORS.BLUE,
  getLineWidth: 1,
  positionFormat: "XY",
  visible: true,
} as const;

export const DEFAULT_ICON_LAYER_PROPS: Partial<IconLayerProps<XYLocation>> = {
  iconAtlas: IconAtlas,
  iconMapping: ICON_MAPPING,
  sizeUnits: "pixels",
  getSize: 25,
  getPosition: (d) => d,
  pickable: true,
  billboard: false,
} as const;

export const DEFAULT_POINT_LAYER_PROPS: Partial<ScatterplotLayerProps<XYLocation>> = {
  getPosition: (d) => d,
  getRadius: 7,
  getFillColor: COLORS.BLUE,
  radiusUnits: "pixels",
  pickable: true,
  billboard: false,
};
